import { render, staticRenderFns } from "./cavu-button.vue?vue&type=template&id=c3a89fb6&scoped=true"
import script from "./cavu-button.vue?vue&type=script&lang=ts"
export * from "./cavu-button.vue?vue&type=script&lang=ts"
import style0 from "./cavu-button.vue?vue&type=style&index=0&id=c3a89fb6&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a89fb6",
  null
  
)

export default component.exports